import Button from './atoms/Button';
import { useDeleteUserEventMutation } from '../store';

interface Props {
  sellsCount: number;
  userEventId: string;
  businessId: string;
  eventId: string;
  onCancel: () => void;
  onDeleteSuccess: () => void;
}

const DeleteSeller: React.FC<Props> = ({
  sellsCount, userEventId, businessId, eventId, onCancel, onDeleteSuccess,
}) => {
  const [deleteUserEvent, { isLoading: isDeleteUserEventLoading }] = useDeleteUserEventMutation();

  const handleDeleteUserEvent = async () => {
    await deleteUserEvent({ businessId, eventId, userEventId }).unwrap();
    onDeleteSuccess();
  };

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-lg font-medium">Eliminar vendedor</h1>
      {sellsCount === 0 ? (
        <>
          <div className="flex flex-col gap-2">
            <p>¿Deseas eliminar a este vendedor?</p>
            <p className="mt-2">
              Una vez eliminado desaparecerá de la lista y no se podrá
              revertir.
            </p>
          </div>
          <div className="flex gap-3">
            <Button loading={isDeleteUserEventLoading} onClick={onCancel} variant="secondary">
              Cancelar
            </Button>
            <Button
              loading={isDeleteUserEventLoading}
              disabled={sellsCount > 0}
              onClick={handleDeleteUserEvent}
            >
              Eliminar
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col gap-2">
            <p>Este vendedor no puede ser eliminado porque tiene entradas vendidas.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default DeleteSeller;
